import React from "react";
import {DataTableColumnProps} from "peggirkit";
import {FormattedMessage, IntlShape} from "react-intl";
import DateTimeFormatter from "@widgets/employees/editor/timeEntries/columns/DateTimeFormatter";
import {EmployeeTimeEntryDataTable} from "@widgets/employees/editor/timeEntries/ClockedHoursOverview";
import WorkedHoursSummaryFormatter from "@widgets/employees/editor/timeEntries/columns/WorkedHoursSummaryFormatter";
import EditEntryOptions from "@widgets/employees/editor/timeEntries/columns/EditEntryOptions";
import {SetStateFn} from "@/utils/SetStateUtils";

export const getClockedHoursDataTableColumns = (
    intl: IntlShape,
    setLastUpdated: SetStateFn<Date>,
): DataTableColumnProps<EmployeeTimeEntryDataTable>[] => ([
    {
        id: "id",
        label: {displayName: intl.formatMessage({id: "id"})},
        primary: false,
        visibility: "always-hidden",
    },
    {
        id: "clockIn",
        label: {displayName: intl.formatMessage({id: "clockedIn"})},
        primary: true,
        sortingConfig: {
            enabled: true,
            sorted: "desc",
        },
        align: "left",
        formatter: (clockIn: string,) => <DateTimeFormatter date={clockIn}/>,
    },
    {
        id: "clockOut",
        label: {displayName: intl.formatMessage({id: "clockedOut"})},
        primary: true,
        sortingConfig: {
            enabled: true,
        },
        align: "left",
        formatter: (clockOut: string | null) => clockOut === null
            ? "-"
            : <DateTimeFormatter date={clockOut}/>,
    },
    {
        id: "breakMinutes",
        label: {displayName: intl.formatMessage({id: "paused"})},
        primary: true,
        sortingConfig: {
            enabled: true,
        },
        align: "left",
        formatter: (breakMinutes: number) => (
            <FormattedMessage
                id={"nMinutes"}
                values={{n: breakMinutes}}
            />
        ),
    },
    {
        id: "summary",
        label: {displayName: intl.formatMessage({id: "workedHours"})},
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (_, {clockIn, clockOut, breakMinutes, id}) => (
            <WorkedHoursSummaryFormatter
                timeEntry={{id, clockIn, clockOut, breakMinutes}}
            />
        ),
    },
    {
        id: "options",
        label: {
            displayName: intl.formatMessage({id: "options"}),
            hide: true,
        },
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (_, entry) => (
            <EditEntryOptions
                setLastUpdated={setLastUpdated}
                entry={entry}
            />
        ),
    },
]);